<script>
import {defineComponent} from "vue";
import BrandBanner from "@/components/website/BrandBanner.vue";
import BrandValues from "@/components/website/BrandValues.vue";
import BrandAbout from "@/components/website/BrandAbout.vue";
import BrandApartHotels from "@/components/website/BrandApartHotels.vue";
import BrandFounders from "@/components/website/BrandFounders.vue";
import MainConcept from "@/components/website/MainConcept.vue";

export default defineComponent({
  components: {
    MainConcept,
    BrandFounders,
    BrandApartHotels,
    BrandAbout,
    BrandValues,
    BrandBanner,
  },
  setup() {
    return {
    };
  }
})
</script>

<template>
  <section class="brand">
    <BrandBanner />
    <MainConcept />
    <BrandValues type="values" />
    <BrandAbout />
    <BrandValues type="advantages" />
    <BrandApartHotels />
    <BrandFounders />
  </section>
</template>